__turbopack_context__.v({
  "body": "MoveToSharedFolderModal-module__0UNooW__body",
  "ctaButtons": "MoveToSharedFolderModal-module__0UNooW__ctaButtons",
  "modalContent": "MoveToSharedFolderModal-module__0UNooW__modalContent",
});
